/**
 * StructureIntegrity provider class
 * Maps object structure to required array structures
 */
import { TicketSelectionApplicationData } from "@/domain/ticket-selection";

export class StructureIntegrityProvider {

    /**
     * whatItDoes
     * Maps non-array entities to array structure - if possible
     */
    public static mapToExpectedArrayFrom(supposedArray: any): any[] {
        if (supposedArray === undefined || supposedArray === null) {
            return [];
        }

        if (Array.isArray(supposedArray)) {
            return supposedArray;
        }

        if (typeof supposedArray === 'function') {
            throw new Error('Expected array ' + supposedArray + ' is function. No conversion possible!');
        }

        if (Object(supposedArray) !== supposedArray) {
            throw new Error('Expected array ' + supposedArray + ' is not undefined and not an object. No conversion possible!');
        }

        return Object.values(supposedArray);
    }

    /**
     * whatItDoes
     * Insures that PriceList structure conforms to required structural contract
     */
    public static provideIntegrityForApplication(data: TicketSelectionApplicationData): TicketSelectionApplicationData {
        if (!data.priceList) {
            return data;
        }

        if (!Array.isArray(data.priceList.priceLevels)) {
            data.priceList.priceLevels = this.mapToExpectedArrayFrom(data.priceList.priceLevels);
        }

        if (data.priceList.priceLevels.length === 0) {
            return data;
        }

        data.priceList.priceLevels.map(priceLevel => {
            if (!Array.isArray(priceLevel.promotionHolds)) {
                priceLevel.promotionHolds = this.mapToExpectedArrayFrom(priceLevel.promotionHolds);
            }

            priceLevel.promotionHolds.map(promotionHold => {
                if (!Array.isArray(promotionHold.holds)) {
                    promotionHold.holds = this.mapToExpectedArrayFrom(promotionHold.holds);
                }

                promotionHold.holds.map(hold => {
                    if (!Array.isArray(hold.ticketTypes)) {
                        hold.ticketTypes = this.mapToExpectedArrayFrom(hold.ticketTypes);
                    }

                    return hold;
                });
                return promotionHold;
            });
            return priceLevel;
        });

        if (!Array.isArray(data.priceList.promotions)) {
            data.priceList.promotions = this.mapToExpectedArrayFrom(data.priceList.promotions);
        }

        return data;
    }

}
